import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../../Router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import TableTop from "../../../Components/UI/TableTop";
import Loader from "../../../feature-module/loader/loader";
import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { Edit, PlusCircle } from "feather-icons-react/build/IconComponents";
import Error404 from "../../ErrorPages/error404";
import DesignationForm from "./DesignationForm";
import { useForm, FormProvider } from "react-hook-form";
import { loggedInUser } from "../../../core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import ToastNotification from "../../../Components/UI/ToastNotification";
import { yupResolver } from "@hookform/resolvers/yup";
import { designationValidationSchema } from "../../../core/Operations/ValidationSchema/MasterValidationSchema";
import { useGetAllDesignationQuery } from "../../../AppQuries/master/Designation/get-all-designations";
import { useAddDesignationMutation } from "../../../AppQuries/master/Designation/add-designation";
import { useUpdateDesignationMutation } from "../../../AppQuries/master/Designation/update-designation";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import ReportTools from "Components/UI/ReportTools";
import { Switch } from "antd";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const DesignationList = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };
  const methods = useForm({
    defaultValues: {
      code: 0,
      isActive: 1,
      companyCode: userData.companyCode,
      createUser: userData.userName,
      modifyUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(designationValidationSchema),
  });
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: GetDesignations,
  } = useGetAllDesignationQuery({
    companyCode: userData?.companyCode,
    isTrue: showActiveOnly,
  });
  const { mutate: addDesignation } = useAddDesignationMutation();
  const { mutate: updateDesignation } = useUpdateDesignationMutation();
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const designationData = data?.data.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const { setSearchValue, filteredData } = useTableSearch(designationData, [
    "description",
    "isActive",
  ]);

  const handleAddClick = () => {
    setSelectedDesignation(null);
    methods.reset({
      companyCode: userData.companyCode,
      description: "",
      isActive: 1,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (designation) => {
    setSelectedDesignation(designation);
    methods.reset({
      companyCode: designation.companyCode,
      description: designation.description,
      isActive: designation.isActive ? 1 : 0,
      createUser: designation.createUser,
      createDate: designation.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    if (selectedDesignation) {
      payload.code = selectedDesignation.code;
      updateDesignation(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Designation Updated Successfully.");
            setSelectedDesignation(null);
            setShow(false);
            GetDesignations();
          } else {
            toast.warning("Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      payload.code = 0;
      addDesignation(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Designation Added Successfully.");

            setShow(false);
            GetDesignations();
          } else {
            toast.warning(error.message || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  useEffect(() => {
    if (isMount) {
      GetDesignations();
    }
    setIsMount(true);
  }, [showActiveOnly]);

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const columns = [
    {
      title: "SNo",
      dataIndex: "id",
    },
    {
      title: "Designation Name",
      dataIndex: "description",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <td className="action-table-data">
          <Can
            accessModule={accessCodes.human_resources}
            accessCode={accessCodes.designations}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
        </td>
      ),
    },
  ];

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Designations</h4>
                <h6>Manage your Designations</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Designation Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetDesignations}
              />
            </div>
            <div className="page-btn">
              <Can
                accessModule={accessCodes.human_resources}
                accessCode={accessCodes.designations}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add New Designation</Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add New Designation
                  </Link>
                </OverlayTrigger>
              </Can>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={true}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) =>
                                  setShowActiveOnly(checked)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <DesignationForm
          mode={selectedDesignation ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </div>
  );
};

export default DesignationList;
